/**
 * Extracts a numeric patient ID from an API URL string like "/api/patients/123".
 * Returns `undefined` when the ID is missing or doesn't contain a valid number.
 */
export function parsePatientIdFromUrl(url: string | undefined | null): number | undefined {
    if (!url) return undefined;
    const id = Number(url.split('/')[3]);
    return Number.isNaN(id) ? undefined : id;
}
